const obj = {
    getBrandList: '/goods/brand/getBrandList', //品牌列表
    editBrand: '/goods/brand/editBrand', //修改品牌
    addBrand: '/goods/brand/addBrand', //添加品牌
    findBrandById: '/goods/brand/findBrandById/', //{id}  回显
    cancelBrands: '/goods/brand/cancelBrands', //删除 批量删除 id数组
    updateRecommend:'/goods/brand/updateRecommend',//品牌关联
    getRecommedBrandList:'/goods/brand/getRecommedBrandList',//获取品牌列表
    getCategorys: "/goods/categoryBrand/getCategorys/",
    /*获取品牌关联类目*/
    queryName: '/goods/brand/queryName', //品牌名称搜索
    getLevelCategory: "/goods/category/getCategoryBrands", //获取类目列表
    addCategoryBrands: "/goods/categoryBrand/addCategoryBrands" /*保存关联类目*/
}
export default obj;